// 本地环境配置
module.exports = {
  title: '共创家—平台后台管理',
  baseUrl: 'http://applet1.jifenxitong.com/', // 项目地址
  baseApi: '/admin', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  $cdn: ''
};
